/* ---------------------------------------------------------
   SALEEQA - CM / IN MEASUREMENT TOGGLE

   Finds every measurement table in rich text (product
   descriptions and the Size Guide page), adds a CM / IN pill
   above it, and converts the figures in place.

   Tables are recognised by their header row containing
   measurement words, so nothing in the descriptions needs
   editing and new products pick this up automatically.

   Default: inches for US visitors, centimetres for everyone
   else. A choice made by the visitor is kept for the session.
   --------------------------------------------------------- */

(function () {
  'use strict';

  var KEY = 'slqa-units';
  var HEAD_WORDS = ['chest', 'length', 'sleeve', 'shoulder', 'width'];

  function initialUnit() {
    try {
      var saved = sessionStorage.getItem(KEY);
      if (saved === 'cm' || saved === 'in') return saved;
    } catch (e) {}
    return window.SLQA_COUNTRY === 'US' ? 'in' : 'cm';
  }

  var unit = initialUnit();

  function isMeasureTable(table) {
    var head = table.querySelector('thead') || table.querySelector('tr');
    if (!head) return false;
    var text = head.textContent.toLowerCase();
    for (var i = 0; i < HEAD_WORDS.length; i++) {
      if (text.indexOf(HEAD_WORDS[i]) !== -1) return true;
    }
    return false;
  }

  function prepare(table) {
    if (table.hasAttribute('data-slqa-units')) return;
    table.setAttribute('data-slqa-units', '');

    /* Remember the original centimetre value on every numeric
       cell, so switching back is exact rather than recalculated. */
    Array.prototype.forEach.call(table.querySelectorAll('tbody td'), function (td) {
      var raw = td.textContent.trim();
      if (/^-?\d+(\.\d+)?$/.test(raw)) td.setAttribute('data-cm', raw);
    });

    var row = document.createElement('div');
    row.className = 'SlqaUnitsRow';
    row.innerHTML =
      '<div class="SlqaUnits" role="group" aria-label="Measurement units">' +
        '<button type="button" data-u="cm">CM</button>' +
        '<button type="button" data-u="in">IN</button>' +
      '</div>';
    table.parentNode.insertBefore(row, table);
  }

  function toInches(cm) {
    return (parseFloat(cm) / 2.54).toFixed(1);
  }

  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll('table[data-slqa-units] td[data-cm]'), function (td) {
      var cm = td.getAttribute('data-cm');
      td.textContent = unit === 'in' ? toInches(cm) : cm;
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-slqa-cm-text]'), function (p) {
      var original = p.getAttribute('data-slqa-cm-text');
      p.innerHTML = unit === 'in' ? original.replace(/centimetres/g, 'inches') : original;
    });

    Array.prototype.forEach.call(document.querySelectorAll('.SlqaUnits button'), function (b) {
      var on = b.getAttribute('data-u') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    var found = false;

    Array.prototype.forEach.call(document.querySelectorAll('.Rte table'), function (table) {
      if (isMeasureTable(table)) {
        prepare(table);
        found = true;
      }
    });

    if (!found) return;

    /* Captions such as "All measurements in centimetres" switch
       wording along with the figures. */
    Array.prototype.forEach.call(document.querySelectorAll('.Rte p'), function (p) {
      if (!p.hasAttribute('data-slqa-cm-text') && /centimetres/.test(p.innerHTML)) {
        p.setAttribute('data-slqa-cm-text', p.innerHTML);
      }
    });

    apply();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.SlqaUnits button[data-u]') : null;
    if (!b) return;
    e.preventDefault();
    unit = b.getAttribute('data-u');
    try { sessionStorage.setItem(KEY, unit); } catch (err) {}
    apply();
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  window.addEventListener('load', init);
})();
